export default __webpack_public_path__ + "static/media/Slider-1.8e6d65c2.png";